import PropTypes from 'prop-types';
import { useApplicantData } from './useApplicantData';
import { getApplicantData } from '../util/helpers/applicantDataHelper';

const useApplicationOwnerCountry = (applicantType) => {
  const ApplicantData = useApplicantData(applicantType);

  const identityCountry = getApplicantData(
    ApplicantData,
    'PersonCountry',
    'CountryIso3Code',
  );

  return { identityCountry };
};

useApplicationOwnerCountry.propTypes = {
  applicantType: PropTypes.string,
};

export default useApplicationOwnerCountry;
